export default __webpack_public_path__ + "static/xy-histogram-with-mean-aggregation-3e31ba205f09fa345f8de1dda16d8696.png";